"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _reactBootstrap = require("react-bootstrap");

var _reactIntl = require("react-intl");

var _selectn = require("selectn");

var _selectn2 = _interopRequireDefault(_selectn);

var _tcombForm = require("tcomb-form");

var _tcombForm2 = _interopRequireDefault(_tcombForm);

var _lodash = require("lodash");

var _uuid = require("uuid");

var uuid = _interopRequireWildcard(_uuid);

var _StatusWrapper = require("../../../components/StatusWrapper");

var _StatusWrapper2 = _interopRequireDefault(_StatusWrapper);

var _reactRedux = require("react-redux");

var _mapToState = require("../../mapToState");

var _actions = require("../../reducers/reportDetail/actions");

var reportDetailActions = _interopRequireWildcard(_actions);

var _TCombFormWrapper = require("../../../components/TCombFormWrapper");

var _TCombFormWrapper2 = _interopRequireDefault(_TCombFormWrapper);

var _TcombReactWidgetsComboBox = require("../../../components/TcombReactWidgetsComboBox");

var _TcombReactWidgetsComboBox2 = _interopRequireDefault(_TcombReactWidgetsComboBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var Form = _tcombForm2.default.form.Form;

var LINKED_TYPE_SPLITTER = "__LINKED_TYPE__";
var getFormSchema = function getFormSchema(props, currentReportData) {
    var additionalInfoTitle = currentReportData.dataDefinition.additionalInfoTitle;

    var predefinitions = (0, _selectn2.default)("predefinitions", currentReportData.dataDefinition);
    var reportDataContents = (0, _lodash.chain)(props.reportDetail.reportData).filter(function (reportData) {
        return reportData.dataKey !== "issues";
    }).value();
    var schema = {
        title: _tcombForm2.default.String
    };
    if (additionalInfoTitle) {
        schema = Object.assign(schema, {
            additionalInfo: _tcombForm2.default.maybe(_tcombForm2.default.String)
        });
    }
    if (currentReportData.dataKey === "issues") {
        schema = Object.assign(schema, {
            description: _tcombForm2.default.maybe(_tcombForm2.default.String)
        });
        if (predefinitions && predefinitions.length > 0) {
            schema = Object.assign(schema, {
                category: _tcombForm2.default.maybe(_tcombForm2.default.String) // can be optionally set at issues (hiding title details with a subcategory selector)
            });
        }
        (0, _lodash.chain)(reportDataContents).filter(function (reportData) {
            return reportData.dataKey !== "issues";
        }).forEach(function (reportData) {
            (0, _lodash.set)(schema, reportData.dataKey + LINKED_TYPE_SPLITTER + reportData.dataDefinition.uid, _tcombForm2.default.maybe(_tcombForm2.default.String));
        }).value();
    }
    return _tcombForm2.default.struct(schema);
};
var schemaOptions = function schemaOptions(props, state, currentReportData, formatMessage) {
    var additionalInfoTitle = currentReportData.dataDefinition.additionalInfoTitle;

    var schemaOptions = {
        fields: {
            title: {
                label: React.createElement("span", null, currentReportData.dataDefinition.nameSingular, React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.type.new.modal.title.postfix" })),
                error: React.createElement("i", null, React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.type.new.modal.title.validationError" })),
                attrs: {
                    autoFocus: true
                }
            },
            additionalInfo: {
                label: additionalInfoTitle
            }
        }
    };
    if (currentReportData.dataKey === "issues") {
        (function () {
            var categoryOptions = void 0,
                categoryItemOptions = void 0;
            var predefinitions = (0, _selectn2.default)("predefinitions", currentReportData.dataDefinition);
            if (predefinitions) {
                categoryOptions = (0, _lodash.chain)(predefinitions).map(function (item) {
                    return {
                        value: item.categoryName,
                        text: item.categoryName
                    };
                }).value();
                categoryItemOptions = (0, _lodash.chain)(predefinitions).filter(function (item) {
                    return item.categoryName === state.currentFormData.category;
                }).map(function (category) {
                    return (0, _lodash.chain)(category.issueTitles).map(function (issueTitle) {
                        return {
                            value: issueTitle,
                            text: issueTitle
                        };
                    }).value();
                }).flatten().value();
            }
            schemaOptions.fields.category = {
                label: React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.type.new.modal.predefinitions.category.title" }),
                error: React.createElement("i", null, React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.type.new.modal.predefinitions.category.validationError" })),
                options: categoryOptions,
                factory: _tcombForm2.default.form.Select
            };
            // category selection at issues must always be optional!
            // override title field with category items if available, but only if category is definately currently selected!
            if (categoryOptions.length > 0 && (0, _lodash.isString)(state.currentFormData.category) && (0, _lodash.isEmpty)(state.currentFormData.category) === false) {
                schemaOptions.fields.title = {
                    label: React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.type.new.modal.predefinitions.category.item.title" }),
                    error: React.createElement("i", null, React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.type.new.modal.predefinitions.category.item.validationError" })),
                    options: categoryItemOptions,
                    factory: _tcombForm2.default.form.Select
                };
            }
            (0, _lodash.set)(schemaOptions.fields, "description", {
                label: React.createElement(_reactIntl.FormattedMessage, { id: "reportDetail.type.new.modal.description.title" })
            });
            // set custom order for add issue form
            var orderArray = ["category", "title", "description"];
            (0, _lodash.chain)(props.reportDetail.reportData).filter(function (reportData) {
                return reportData.dataKey !== "issues";
            }).map(function (reportData) {
                return (0, _lodash.chain)(reportData.dataEntries).map(function (entry) {
                    return {
                        value: entry.uid,
                        text: entry.title
                    };
                }).thru(function (options) {
                    var field = {
                        label: reportData.dataDefinition.nameSingular,
                        options: options,
                        factory: _tcombForm2.default.form.Select
                    };
                    (0, _lodash.set)(schemaOptions.fields, reportData.dataKey + LINKED_TYPE_SPLITTER + reportData.dataDefinition.uid, field);
                    orderArray.push(reportData.dataKey + LINKED_TYPE_SPLITTER + reportData.dataDefinition.uid);
                    return field;
                }).value();
            }).value();
            (0, _lodash.set)(schemaOptions, "order", orderArray);
        })();
    } else {
        var _predefinitions = (0, _selectn2.default)("predefinitions", currentReportData.dataDefinition);
        if (_predefinitions) {
            schemaOptions.fields.title.template = _TcombReactWidgetsComboBox2.default;
            schemaOptions.fields.title.config = {
                reactWidgetConfig: {
                    messages: {
                        emptyList: formatMessage({ id: "reportDetail.type.new.modal.predefinitions.list.empty" }, { namePlural: currentReportData.dataDefinition.namePlural }),
                        emptyFilter: formatMessage({ id: "reportDetail.type.new.modal.predefinitions.list.nomatch" }, { namePlural: currentReportData.dataDefinition.namePlural })
                    },
                    //data: _difference(_map(predefinitions, (predef: any) => predef.title), _map(currentReportData.dataEntries, (entry: any) => entry.title)),
                    data: (0, _lodash.map)((0, _lodash.filter)(_predefinitions, function (predef) {
                        return !predef.createInstance;
                    }), function (predef) {
                        return predef.title;
                    }),
                    suggest: true,
                    filter: "startsWith"
                }
            };
        }
    }
    return schemaOptions;
};
var ReportDetailAddEditTypeModal = function (_React$Component) {
    _inherits(ReportDetailAddEditTypeModal, _React$Component);

    function ReportDetailAddEditTypeModal(props) {
        _classCallCheck(this, ReportDetailAddEditTypeModal);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ReportDetailAddEditTypeModal).call(this, props));

        _this.onHide = function (e) {
            _this.props.onClose();
        };
        _this.onFormChange = function (data) {
            _this.setState({
                currentFormData: data,
                isLoading: _this.state.isLoading
            });
        };
        _this.onFormSubmit = function (e) {
            e.preventDefault();
            var tempRefs = _this.refs;
            var data = tempRefs.form.getValue();
            if (data) {
                (function () {
                    var updatedReportData = null;
                    // if there is a saveReportBeforeAddType set, save current report and add afterwards the new type
                    if (_this.props.saveReportBeforeAddType) {
                        (function () {
                            var promise = _this.props.dispatch(reportDetailActions.saveSelectedReport()).then(function (value) {
                                updatedReportData = _this.getUpdatedReportData(data);
                                return _this.props.dispatch(reportDetailActions.updateReport(updatedReportData.selectedReport));
                            });
                            (0, _mapToState.mapToState)(function () {
                                return _this;
                            }, function () {
                                return promise.then(function (value) {
                                    _this.props.onSuccess(updatedReportData.uid);
                                });
                            });
                        })();
                    } else {
                        updatedReportData = _this.getUpdatedReportData(data);
                        (0, _mapToState.mapToState)(function () {
                            return _this;
                        }, function () {
                            return _this.props.dispatch(reportDetailActions.updateReport(updatedReportData.selectedReport)).then(function (value) {
                                _this.props.onSuccess(updatedReportData.uid);
                            });
                        });
                    }
                })();
            }
        };
        _this.state = {
            currentFormData: {},
            isLoading: false
        };
        return _this;
    }

    _createClass(ReportDetailAddEditTypeModal, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            // clear the state everytime the show flag switches!
            if (nextProps.showModal === true && this.props.showModal === false) {
                if (nextProps.mode === "add") {
                    this.setState({
                        currentFormData: {},
                        isLoading: false
                    });
                } else if (nextProps.mode === "edit" && nextProps.selectedItem !== null) {
                    // mode edit must be handled differently here, form data of the current selected needs to be injected here.
                    // we need to apply the selectedItem data (issue, item or object) to the currentFormData!
                    var currentReportData = (0, _lodash.head)((0, _lodash.chain)(nextProps.reportDetail.reportData).filter(function (reportData) {
                        return reportData.dataDefinition.uid === nextProps.reportDataDefinitionUid;
                    }).value());

                    (function () {
                        switch (currentReportData.dataKey) {
                            case "issues":
                                var typeIssue = nextProps.selectedItem;
                                // we need to resolve the type references that point to this issue (ref2)...
                                // the identifiers are custom in this case!
                                // generate allowed types...
                                var reportDataContents = (0, _lodash.chain)(nextProps.reportDetail.reportData).filter(function (reportData) {
                                    return reportData.dataKey !== "issues";
                                }).value();
                                var instanceReferences = (0, _lodash.filter)(nextProps.reportDetail.typeReferences, { ref2: typeIssue.uid });
                                var referencesFormDataState = {};
                                (0, _lodash.each)(reportDataContents, function (reportData) {
                                    var mapFormValueIdentifier = reportData.dataKey + LINKED_TYPE_SPLITTER + reportData.dataDefinition.uid;
                                    // lookup a set identifier for this mapFormValueIdentifier from the instanceReferences...
                                    var foundReferenceUid = (0, _lodash.reduce)(instanceReferences, function (foundEntry, reference) {
                                        var relevantDataEntry = (0, _lodash.find)(nextProps.reportDetail.reportData, { dataKey: reportData.dataKey, dataDefinition: { uid: reportData.dataDefinition.uid } });
                                        // try to find the referenced id...
                                        var found = (0, _lodash.find)(relevantDataEntry.dataEntries, { uid: reference.ref1 });
                                        if (found) {
                                            // console.log(found);
                                            return found.uid;
                                        }
                                        // noop else.
                                        return foundEntry;
                                    }, null);
                                    if (foundReferenceUid) {
                                        console.log("found refernce to assign in form", mapFormValueIdentifier, foundReferenceUid);
                                        // add the mapFormValueIdentifier to the currentFormData state!
                                        referencesFormDataState[mapFormValueIdentifier] = foundReferenceUid;
                                    }
                                });
                                _this2.setState({
                                    currentFormData: Object.assign({}, {
                                        title: typeIssue.title,
                                        description: typeIssue.description
                                    }, referencesFormDataState),
                                    isLoading: false
                                });
                                break;
                            case "objects":
                                var typeObject = nextProps.selectedItem;
                                _this2.setState({
                                    currentFormData: {
                                        title: typeObject.title,
                                        additionalInfo: typeObject.additionalInfo
                                    },
                                    isLoading: false
                                });
                                break;
                            case "items":
                                var typeItem = nextProps.selectedItem;
                                _this2.setState({
                                    currentFormData: {
                                        title: typeItem.title,
                                        additionalInfo: typeItem.additionalInfo
                                    },
                                    isLoading: false
                                });
                                break;
                        }
                    })();
                }
            }
        }
    }, {
        key: "getUpdatedReportData",
        value: function getUpdatedReportData(data) {
            var _this3 = this;

            var currentReportData = (0, _lodash.head)((0, _lodash.chain)(this.props.reportDetail.reportData).filter(function (reportData) {
                return reportData.dataDefinition.uid === _this3.props.reportDataDefinitionUid;
            }).value());
            var dataKey = currentReportData.dataKey;
            var dataEntries = currentReportData.dataEntries;
            var selectedReport = this.props.reportDetail.selectedReport;
            var dataDefinition = currentReportData.dataDefinition;

            var dataType = {};
            switch (dataKey) {
                case "issues":
                    if (data.category && data.categoryItem) {
                        dataType = Object.assign(dataType, {
                            categoryName: data.category,
                            title: data.categoryItem
                        });
                    }
                    dataType = Object.assign(dataType, {
                        issueTypeUid: dataDefinition.uid,
                        description: data.description
                    });
                    break;
                case "objects":
                    dataType = { objectTypeUid: dataDefinition.uid };
                    break;
                case "items":
                    dataType = { itemTypeUid: dataDefinition.uid };
                    break;
            }
            // if we are in mode edit, we need to reuse the already submitted id.
            var dataWithUuid = Object.assign(Object.assign({}, data, dataType), {
                // generate a new uid or reuse the current uid if we are in edit mode.
                uid: this.props.mode === "add" ? uuid.v4() : this.props.selectedItem.uid
            });
            // if we are manupulating issues, we also need to generate and include the typeReferences...
            if (dataKey === "issues") {
                (function () {
                    // issues need to be handled in this extra step...
                    var issueData = {
                        attachmentUids: [],
                        description: dataWithUuid.description,
                        issueTypeUid: dataWithUuid.issueTypeUid,
                        title: dataWithUuid.title,
                        uid: dataWithUuid.uid
                    };
                    if (dataWithUuid.categoryName) {
                        issueData.categoryName = dataWithUuid.categoryName;
                    }
                    if (_this3.props.mode === "add") {
                        selectedReport.data[dataKey].push(issueData);
                    } else if (_this3.props.mode === "edit") {
                        // we need to find and update the current existing issue...
                        var toManipulateIssueIndex = (0, _lodash.findIndex)(selectedReport.data[dataKey], { uid: _this3.props.selectedItem.uid });
                        selectedReport.data[dataKey][toManipulateIssueIndex] = issueData; // update
                    } else {
                        throw new Error(_this3.props.mode + " encountered, not implemented mode.");
                    }
                    // we will always remove and add the typereferences...
                    // wipe all typeReferences that match this issue item...
                    (0, _lodash.remove)(selectedReport.data.typeReferences, function (typeRef) {
                        // ref 2 will always point to this issue, other references are unsupported.
                        return typeRef.ref2 === dataWithUuid.uid;
                    });
                    // inject the new typeReferences...
                    var linkedProperties = [];
                    (0, _lodash.forOwn)(data, function (referencedInstance, key) {
                        if (key.indexOf(LINKED_TYPE_SPLITTER) !== -1 && (0, _lodash.isString)(referencedInstance) === true) {
                            var linkInformation = key.split(LINKED_TYPE_SPLITTER); // type of type on the left, specific item on the right.
                            // we are interested in further processing this linked type reference...
                            linkedProperties.push({
                                ref1: referencedInstance,
                                ref2: dataWithUuid.uid,
                                refType: linkInformation[0] === "objects" ? "object-issue" : "item-issue" // "object-issue" or "item-issue"
                            });
                        }
                    });
                    selectedReport.data.typeReferences = (0, _lodash.union)(selectedReport.data.typeReferences, linkedProperties);
                })();
            } else {
                if (this.props.mode === "add") {
                    // handle objects and items...
                    selectedReport.data[dataKey].push(dataWithUuid);
                } else if (this.props.mode === "edit") {
                    var toManipulateIssueIndex = (0, _lodash.findIndex)(selectedReport.data[dataKey], { uid: this.props.selectedItem.uid });
                    selectedReport.data[dataKey][toManipulateIssueIndex] = dataWithUuid; // update
                } else {
                    throw new Error(this.props.mode + " encountered, not implemented mode.");
                }
            }
            return {
                selectedReport: selectedReport,
                uid: dataWithUuid.uid
            };
        }
    }, {
        key: "render",
        value: function render() {
            var _this4 = this;

            var formatMessage = this.props.intl.formatMessage;

            var modal = null;
            var currentReportData = (0, _lodash.head)((0, _lodash.chain)(this.props.reportDetail.reportData).filter(function (reportData) {
                return reportData.dataDefinition.uid === _this4.props.reportDataDefinitionUid;
            }).value());
            if (currentReportData) {
                var schema = getFormSchema(this.props, currentReportData);
                modal = React.createElement(_reactBootstrap.Modal, { show: this.props.showModal, onHide: this.onHide, enforceFocus: false }, React.createElement(_StatusWrapper2.default, { isLoading: this.state.isLoading, error: this.state.error, onDismissError: this.state.dismissError }, React.createElement(_reactBootstrap.Modal.Header, { closeButton: true }, React.createElement(_reactBootstrap.Modal.Title, null, currentReportData.dataDefinition.nameSingular, " ", React.createElement(_reactIntl.FormattedMessage, { id: this.props.mode === "add" ? "reportDetail.type.empty.postfix" : "reportDetail.type.empty.postfix.edit" }))), React.createElement(_reactBootstrap.Modal.Body, null, React.createElement(_TCombFormWrapper2.default, { onSubmit: this.onFormSubmit, ref: "form", type: schema, options: schemaOptions(this.props, this.state, currentReportData, this.props.intl.formatMessage), value: this.state.currentFormData, onChange: this.onFormChange })), React.createElement(_reactBootstrap.Modal.Footer, null, React.createElement(_reactBootstrap.Row, null, React.createElement(_reactBootstrap.Col, { xs: 12 }, React.createElement(_reactBootstrap.ButtonGroup, null, React.createElement(_reactBootstrap.Button, { bsStyle: "primary", onClick: this.onFormSubmit }, React.createElement(_reactIntl.FormattedMessage, { id: this.props.mode === "add" ? "reportDetail.type.empty.postfix.first.uppercase" : "reportDetail.type.empty.postfix.first.uppercase.edit" }))))))));
            }
            return modal;
        }
    }]);

    return ReportDetailAddEditTypeModal;
}(React.Component);
ReportDetailAddEditTypeModal = __decorate([_reactIntl.injectIntl, (0, _reactRedux.connect)(function (state) {
    return {
        reportDetail: state.reportDetail
    };
})], ReportDetailAddEditTypeModal);
exports.default = ReportDetailAddEditTypeModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/reportDetail/ReportDetailAddEditTypeModal.tsx
 ** module id = 221
 ** module chunks = 0
 **/